import Timeline from '../../../components/Timeline';
import { Component } from 'react';
import { module1Keys } from './keys';
import { withTranslation } from 'react-i18next';

class PositionDistributionModule1 extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;
        return (
            <Timeline
                chartSize="lg"
                metricType="primary"
                header={t('search.position_distribution.chart.header')}
                data={this.props.data}
                error={this.props.error}
                keys={module1Keys(t)}
                forceRun={this.props.forceRun}
                parent_id={this.props.parent_id}
                content_id={this.props.content_id}
                leftAxisLabel={t('search.position_distribution.chart.leftAxisLabel')}
            />
        );
    }
}

export default withTranslation()(PositionDistributionModule1);
